import * as React from 'react';

import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import {
    createStyles,
    WithStyles,
    withStyles
} from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import Papa from 'papaparse';
import saveCsv from 'save-csv'; // This import requires to add the flag '"esModuleInterop": true' to tsconfig.json
import { ExportToCSVData } from './export-to-csv-data';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const styles = (theme: Theme) => createStyles({
    root: {},
    button: {},
    input: {
        display: 'none',
    }
});

interface Props extends WithStyles<typeof styles> {
    className?: string;
    disabled: boolean;
    importData: boolean;
    onClick?: () => Promise<ExportToCSVData | undefined>;
    onCSVImport?: (data: string[][], ) => void;
    onLoading?: (isLoading: boolean) => void;
}

class CSVButton extends React.Component<Props & ButtonProps> {
    public static defaultProps = {
        disabled: false,
        importData: false
    };
    
    OnImportFromCSVClicked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) {
            return;
        }

        const { onLoading } = this.props;
        if (onLoading) {
            onLoading(true);
        }

        const csvFile = files[0];
        Papa.parse(csvFile, {
            complete: this.OnCSVParsed,
            header: true,
            transformHeader: this.OnCsvTransformHeader,
            skipEmptyLines: 'greedy'
        });
    }
    
    OnCsvTransformHeader = (header: string): string => {
        return header
            .replace(new RegExp(' ', 'g'), '_')
            .toLocaleLowerCase();
    }

    OnCSVParsed = (results: Papa.ParseResult<string[]>) => {
        const { data } = results;
        const {
            onCSVImport,
            onLoading
        } = this.props;

        if (onLoading) {
            onLoading(false);
        }

        if (onCSVImport) {
            onCSVImport(data);
        }
    }

    onExportToCSVClicked = () => {
        const { onClick } = this.props;
        if (!onClick) {
            return;
        }

        onClick()
            .then((results: ExportToCSVData | undefined) => {
                if (!results) {
                    return;
                }

                const {
                    data,
                    fileName
                } = results;
                if (!data || (data.length < 1)) {
                    return;
                }

                const filename = fileName ? fileName : 'noName.csv';
                saveCsv(data, {
                    filename
                });
            })
            .catch(()=> {
                return;
            });
    }

    public render() {
        const {
            classes,
            className,
            children,
            importData,
            ...buttonProps
        } = this.props;
        const mainClasses = `${classes.root}${className ? ` ${className}` : ''}`;
        // this.OnImportFromCSVClicked
        return (
            <div className={mainClasses}>
                { importData ?
                    <input
                        id="csv-button"
                        data-testid="csv-button"
                        className={classes.input}
                        accept=".csv"
                        type="file"
                        onChange={this.OnImportFromCSVClicked}
                    />
                    :''
                }
                { importData ?
                    <label htmlFor="csv-button">
                        <Button
                            {...buttonProps}
                            className={classes.button}
                            component="span"
                        >
                            {children}
                        </Button>
                    </label>
                    :
                    <Button
                        {...buttonProps}
                        className={classes.button}
                        onClick={this.onExportToCSVClicked}
                    >
                        {children}
                    </Button>
                }
            </div>
        );
    }
}

const MUIComponent = withStyles(styles)(CSVButton);
export {MUIComponent as CSVButton};
